import { CompanyCollectorMerchantRepository } from '@domain/company-collector-merchant/repositories/company-collector-merchant.repository';
import { CompanyCollectorMerchantRepositoryService } from '../repositories/company-collector-merchant.service';

export const CompanyCollectorMerchantProvider = [
  {
    provide: CompanyCollectorMerchantRepository,
    useClass: CompanyCollectorMerchantRepositoryService,
  },
];
